<template>
    <nav class="block-menu" :class="{'block-menu--active': isActive}">
        <div class="block-menu__content">
            <div class="block-menu__header">
                <a :href="$store.state.links.pikabu" class="block-menu__header-link block-menu__header-link--pikabu" target="_blank">
                    <img src="./assets/logo-white.svg" class="block-menu__header-link-img">
                </a>
                <a :href="$store.state.links.pik" class="block-menu__header-link block-menu__header-link--pik" target="_blank">
                    <img src="./assets/logo-pik-white.svg" class="block-menu__header-link-img">
                </a>
            </div>
            <ul class="block-menu__items">
                <li class="block-menu__item">
                    <a
                        href="#"
                        class="block-menu__link"
                        :class="{'block-menu__link--active': activeSection === 1}"
                        v-scroll-to="'#section1'"
                        @click.prevent="$emit('click')"
                    >
                        <span class="block-menu__count-wrapper">0-3</span>
                        Первый шаг и&nbsp;прогулки во&nbsp;дворе
                    </a>
                </li>
                <li class="block-menu__item">
                    <a
                        href="#"
                        class="block-menu__link"
                        :class="{'block-menu__link--active': activeSection === 2}"
                        v-scroll-to="'#section2'"
                        @click.prevent="$emit('click')"
                    >
                        <span class="block-menu__count-wrapper">3-6</span>
                        Детский сад и&nbsp;первый кризис
                    </a>
                </li>
                <li class="block-menu__item">
                    <a
                        href="#"
                        class="block-menu__link"
                        :class="{'block-menu__link--active': activeSection === 3}"
                        v-scroll-to="'#section3'"
                        @click.prevent="$emit('click')"
                    >
                        <span class="block-menu__count-wrapper">
                            <span class="block-menu__count">6-12</span>
                        </span>
                        Школьные будни и&nbsp;взросление
                    </a>
                </li>
                <li class="block-menu__item">
                    <a
                        href="#"
                        class="block-menu__link"
                        :class="{'block-menu__link--active': activeSection === 4}"
                        v-scroll-to="'#section4'"
                        @click.prevent="$emit('click')"
                    >
                        <span class="block-menu__count-wrapper">
                            <span class="block-menu__count">12-15</span>
                        </span>
                        Подростки и&nbsp;новые увлечения
                    </a>
                </li>
                <li class="block-menu__item">
                    <a
                        href="#"
                        class="block-menu__link"
                        :class="{'block-menu__link--active': activeSection === 5}"
                        v-scroll-to="'#section5'"
                        @click.prevent="$emit('click')"
                    >
                        <span class="block-menu__count-wrapper">
                            <span class="block-menu__count">15-17</span>
                        </span>
                        Экзамены и&nbsp;начало взрослой жизни
                    </a>
                </li>
            </ul>
            <share />
        </div>
        <div class="block-menu__bg" @click.self="$emit('click')"></div>
    </nav>
</template>

<script>
import share from '@/components/blocks/share'

export default {
    components: {
        share
    },
    props: {
        activeSection: {
            type: Number,
            default: 0
        },
        isActive: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">
    .block-menu {
        position fixed
        width 100%
        height 100%
        z-index 500
        top 0
        left -100%
        transition left .5s step-end

        &--active {
            left 0
            transition initial

            & ^[0]__content {
                transform translateX(0%)
                transition transform .5s ease-out
            }

            & ^[0]__bg {
                opacity 1
            }
        }

        &__content {
            height 100%
            padding 1.5rem 1.7rem
            width 100%
            max-width 28rem
            overflow auto
            display flex
            justify-content flex-start
            flex-flow column nowrap
            background-color $color-yellow
            transform translateX(-100%)
            transition transform .5s ease-in

            +layout-md-and-up() {
                max-width 38.3%
                padding-left 17.3%
            }
        }

        &__header {
            display flex
            justify-content space-between
            align-items center

            +layout-md-and-up() {
                margin 2.8rem 0 2.4rem
            }

            &-link {
                line-height 0

                &-img {
                    width 100%
                    max-width auto
                }

                &--pikabu {
                    +layout-md-and-up() {
                        width 11.6rem
                        transform translateY(1rem)
                    }
                }

                &--pik {
                    +layout-md-and-up() {
                        width 4.3rem
                        margin-right 2.2rem
                    }
                }
            }
        }

        &__items {
            padding 0
            list-style none
            flex-grow 1
            margin 0
        }

        &__item {
            margin-top 2.1rem

            +layout-md-and-up() {
                margin-top 4.2rem
            }
        }

        &__link {
            font-size 1.5rem
            line-height 1
            color $color-white
            display flex
            font-weight 600
            letter-spacing 0.16px
            transition color .15s linear

            &--active,
            &--disabled {
                pointer-events none
            }

            &--active {
                color $color-text
            }

            &--disabled {
                opacity .5
            }
        }

        &__count {
            position relative

            &-wrapper {
                margin-right 1.7rem
                white-space nowrap
                font-size 2.4rem
                letter-spacing 0.26px
                font-weight 600
                width 6.2rem
                flex 0 0 6.2rem
                display inline-block

                +layout-md-and-up() {
                    font-size 2.4rem
                }
            }
        }

        &__soon {
            left 0
            top 100%
            position absolute
            font-size 1.2rem
            letter-spacing 0
            width 100%
            text-align center
        }

        &__bg {
            top 0
            left 0
            right 0
            bottom 0
            opacity 0
            z-index -1
            position absolute
            transition opacity .3s linear
            background-color: rgba(0, 0, 0, 0.5)
        }
    }
</style>
